var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('div',[_c('CookieModal'),_vm._l((_vm.sections),function(section,index){return _c(section.key,{key:index,tag:"component",attrs:{"content":section.content}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }